export const dashboardsI18n = {
  dashboard: {
    shared: {
      newFeatures: {
        header: 'New Features',
        message: 'We are constantly improving our software, new features will come here!',
      },
      meetings: {
        header: 'Next meetings',
      },
    },
    empty: {
      messageCompanyManagerOrHrbp:
        'You currently have no companies with employees to display on the dashboard.\n\nCompanies will appear here once there are active employees to show.',
      messageHr:
        'You currently have no companies with employees to display on the dashboard.\n\nCompanies will appear here once there are active employees to show.',
      messageHrRestricted:
        'There are no companies available on the dashboard.\n\nThis may be because your assigned companies have no employees to display, or because none of the companies you are responsible for are currently available to view here.',
    },
    information: {
      header: 'Information',
      employees: {
        meeting: 'Haven`t talked with your manager for a while? Request a meeting and shape your future.',
        meetingTooltip: 'request a meeting',
        appraisal:
          'It is time for your annual appraisal, use this opportunity, prepare well and push your growth. Have a look on the hints in our service desk',
        appraisalTooltip: 'go to service desk',
        targets: 'Have a look at your targets and close the ones you already reached and set up a meeting with your manager.',
      },
      replyers: {
        adress: 'Did you know, that you can change your address directly on Meply? Have a look in our self-service portal.',
        adressTooltip: 'go to self service portal',
        tour: 'Welcome to Meply! Click here and take a short tour through the tool!',
        tourTooltip: 'take the tamtamy tour',
        notes: 'Saving your best ideas on a napkin is not a good idea? Take notes on Meply and get reminded.',
      },
      manager: {
        probation:
          'Do not forget: If new employees acclimate smoothly, they become a prepared, supported and engaged part of the team. Haven’t planned your probation talks? Have a look here.',
        probationTooltip: 'see the people in probation',
        neglected:
          'Employees who are treated as an integral part of the company’s success tend to be more satisfied and engaged. Are there Replyers you haven`t talked with for a while?',
        neglectedTooltip: 'see the people you have not talked to',
        goals: 'Are there any changes of goals or did some of your people reach their goals? Set up an appraisal.',
        appraisal: 'It is appraisal time! Invite your employees to align on goals, plan their next steps and shape the future together.',
        questions:
          'Do you have questions about Meply and the performance management? Have a look at service desk or ask for our individual training slots.',
      },
      partner: {
        ranking: 'Please do not forget to finalize your ranking as starting point to our annual appraisal!',
      },
    },
    employee: {
      targets: {
        header: 'Targets',
        targetCompleted: 'Congratulations, you completed your target. Do you want to request a meeting?',
        development: {
          header: 'Development Targets',
          noTargets: "Looks like you don't have any development targets. Do you want to request a meeting?",
        },
      },
      nextBirthdays: 'Next Birthdays',
      meetings: {
        managerInviteEmployeeOptionText: 'Do you want to discuss certain topics with {{employeeName}}?',
        managerInviteEmployeesOptionText: 'Do you want to invite someone to a meeting?',
        employeeRequestMeetingText: 'Do you want to discuss a certain topic or update your appraisal?',
        requestTileHeadline: 'Meeting requested',
        requestTileInfo: 'Waiting for {{managerName}} to handle the meeting request',
        withdrawMeetingRequest: 'Withdraw request',
        reschedule: 'Has to be rescheduled by {{reviewer}}',
        prepared: 'Prepared',
        viewPreparation: 'View Preparation',
        preparationPdfNotAvailable: 'Preparation PDF not available',
        pdfGenerationNotStarted: "PDF generation didn't start yet",
        pdfGenerationInProgress: 'PDF generation in progress',
        pdfGenerationError: "There was an error and the PDF couldn't be generated",
        confirm: 'Confirm',
        confirming: 'Confirmation in progress',
        viewPdfAndConfirm: 'View Conclusion & Confirm',
        confirmed: 'Confirmed',
        disputedConfirmed: 'Disputed confirmed',
        canceled: 'Canceled',
      },
      meetingProtocols: {
        viewConclusionPdfButtonText: {
          ready: 'Meeting Conclusion for the meeting held on {{meetingDate}}',
          notReady: 'Meeting Conclusion for the meeting held on {{meetingDate}} is not yet generated',
        },
      },
    },
    companyManager: {
      header: {
        companySelectAria: 'Select company to show dashboard data for',
        companySelectSearchPlaceholder: 'Search company…',
        partialCountryVisibilityAria: 'Restricted country visibility',
        partialCountryVisibilityTooltip:
          'Some countries of this company are outside your HR scope. Dashboard data includes only the countries you are responsible for.',
        countersGroupAria: 'Key metrics for the selected company',
        totalEmployees: {
          label: 'Total employees',
          labelFirstLine: 'Total',
          labelSecondLine: 'Employees',
        },
        newEntries: {
          label: 'New entries',
          labelFirstLine: 'New',
          labelSecondLine: 'Entries',
          infoTooltip: 'Shows employees who joined in the previous or current month.',
          subPreviousMonth: 'Previous M.',
          subCurrentMonth: 'Current M.',
        },
        employeeExits: {
          label: 'Employee exits',
          labelFirstLine: 'Employee',
          labelSecondLine: 'Exit',
          infoTooltip: 'Shows employees who will leave in the current or next month.',
          subCurrentMonth: 'Current M.',
          subNextMonth: 'Next M.',
        },
        probationEnd: {
          label: 'Probation period end',
          labelFirstLine: 'Probation',
          labelSecondLine: 'Period end',
          infoTooltip: 'Shows employees whose probation period ends in the current or next month.',
          subCurrentMonth: 'Current M.',
          subNextMonth: 'Next M.',
        },
        countersQueryError: {
          title: 'Metrics could not be loaded',
          description:
            'The workforce counters for this company are temporarily unavailable. Please try again in a few moments or contact your administrator if the problem persists.',
        },
        workforceModal: {
          openDetailsAria: 'Open details for {{month}}',
          openMainDetailsAria: 'Open all period details for {{label}}',
          validFrom: 'Contract Valid From',
          replyEntryDate: 'Reply Entry Date',
          probationPeriodEndDate: 'Probation Period End Date',
          contractType: 'Contract Type',
          contractCancellationTo: 'Contract End Date',
          contractCancellationType: 'Contract End Reason',
          emptyState: {
            newEntries: {
              previousMonth: {
                info: 'There are no new workforce entries recorded for the previous month for this period.',
              },
              currentMonth: {
                info: 'There are no new workforce entries recorded for this month.',
              },
            },
            employeeExits: {
              currentMonth: {
                info: 'No employees are scheduled to leave during this month.',
              },
              nextMonth: {
                info: 'No employees are scheduled to leave during next month.',
              },
            },
            probationEnd: {
              currentMonth: {
                info: 'No probation end dates fall in this month.',
              },
              nextMonth: {
                info: 'No probation end dates fall in the next month.',
              },
            },
            splitView: {
              allZero: {
                newEntries: {
                  info: 'There are no new workforce entries in the previous or current month.',
                },
                employeeExits: {
                  info: 'There are no employee exits in the current or next month.',
                },
                probationEnd: {
                  info: 'No probation end dates in the current or next month.',
                },
              },
            },
          },
        },
      },
      monitoring: {
        chart: {
          histogramAria: 'Appraisal counts by meeting status',
          invitesGroupTitle: 'SCHEDULED',
          status: {
            Done: 'Closed',
            HavingAnAppraisalUpdate: 'New Appraisal Requested',
            NotInvited: 'To Be Scheduled',
            NotPrepared: 'Company Preparation Required',
            Outdated: 'Expired',
            Prepared: 'Ready For Meeting',
            WaitingForEmployeeConfirmation: 'Pending Employee Confirmation',
            WaitingForHRResult: 'Under HR Review',
          },
        },
        header: {
          title: 'Appraisal Monitoring {{year}}',
          tabListAria: 'Monitoring view tabs',
        },
        footer: {
          text: 'The chart includes only TO DOS. <0>{{count}} appraisal updates</0> are not displayed.',
          textWithCount1: 'The chart includes only TO DOS. <0>{{count}} appraisal update</0> is not displayed.',
          cta: 'Go to <0>YOUR COMPANY</0>',
        },
        table: {
          empty: 'No rows to display.',
          filterByStatus: 'Filter by Status',
          clearFilters: 'Clear filters',
          columns: {
            status: 'Status',
            employee: 'Employee',
            replyEntryDate: 'Reply Date',
            buManagers: 'BU managers',
            bu: 'BU',
            office: 'Office',
            level: 'Level',
            actions: 'Actions',
          },
        },
      },
      filtersArea: {
        header: {
          title: 'Filters Area',
          infoTooltip:
            'Use filters to refine the data displayed in the "Appraisal Monitoring" section.\n\nFrom "Filters Area" you can filter by office, business unit, BU manager, and level.\n\n"Appraisal Monitoring" also has its own meeting status filter (table view only).',
          infoTooltipNoOffice:
            'Use filters to refine the data displayed in the "Appraisal Monitoring" section.\n\nFrom "Filters Area" you can filter by business unit, BU manager, and level.\n\n"Appraisal Monitoring" also has its own meeting status filter (table view only).',
        },
        distributions: {
          header: {
            tabListAria: 'Distribution filter tabs',
          },
          activeFilterLabels: {
            businessUnit: 'BU',
            buManagers: 'BU Manager',
            office: 'Office',
            level: 'Level',
          },
          businessUnit: 'BUs',
          buManagers: 'BU Mgrs',
          office: 'Offices',
          bubobumCountersQueryError: {
            title: 'Distribution counters could not be loaded',
            description: 'Business unit, branch office and BU manager counters are temporarily unavailable. Please try again shortly.',
          },
          boOfCompanyQueryError: {
            title: 'Offices could not be loaded',
            description: 'Branch office data is temporarily unavailable. Please try again shortly.',
          },
          bumOfCompanyQueryError: {
            title: 'BU managers could not be loaded',
            description: 'Business unit manager data is temporarily unavailable. Please try again shortly.',
          },
          buOfCompanyQueryError: {
            title: 'Business units could not be loaded',
            description: 'Business unit data is temporarily unavailable. Please try again shortly.',
          },
          officeList: {
            count: 'Employees in all offices',
            countInSelectedOffice: 'Employees in {{officeName}}',
            countInNoOffice: 'Employees with no office assigned',
          },
          bumList: {
            count: 'BU managers in this company',
          },
          buTab: {
            buManagerRoleLabel: 'BU MANAGER',
            buManagersRoleLabel: 'BU MANAGERS',
            noBuManagerAssigned: 'No BU Manager assigned.',
          },
        },
        pyramids: {
          header: {
            tabListAria: 'Level Pyramid',
          },
          level: 'Level',
          title: 'Pyramid',
          chartAria: 'Level pyramid chart showing current percentage and recommended range per level',
          dotTooltip: {
            current: 'Current',
            recommended: 'Recommended',
          },
          error: {
            title: 'Pyramid data could not be loaded',
            description: 'Level pyramid values are temporarily unavailable. Please try again shortly.',
          },
        },
      },
    },
    manager: {
      employees: {
        header: 'Employees',
      },
      selfReflection: {
        header: 'Self reflection',
        description: 'How satisfied have your employees been with their projects in the last year?',
      },
      nba: {
        header: 'Next best activities',
        emptyText: 'Please click on a bar to see data',
        unknown: {
          header: 'See your employees here',
        },
        noContract: {
          header: 'Employees with a employment ending soon',
          text: 'Watch out! The employment of these people is limited and will end soon. You should care about a new employment for them. ',
        },
        noMeeting: {
          header: 'Employees without regular meeting',
          title: 'no meeting',
          text: 'Employees should have regular meetings with the managers. The employees you see here had no meetings in the last 6 months. Please invite them to a meeting and inform about there general wellbeeing.',
          tableColumns: {
            user: 'Employee',
            businessUnit: 'Business unit',
            date: 'Last meeting',
            action: 'Action',
          },
        },
        onProbation: {
          title: 'probation talk',
          header: 'Probation talk needed',
          text: 'A probation talk meeting must be held before the probation period expires. As part of this meeting you should discuss if the probation period is successful.',
          tableColumns: {
            user: 'Employee',
            businessUnit: 'Business unit',
            date: 'Probation end',
            action: 'Action',
          },
        },
        expiringContract: {
          title: 'employment expires',
          header: 'Employees with expiring employments',
          text: 'These employees have limited term employments that are about to expire. If you want to keep the employee you should take action soon.',
          tableColumns: {
            user: 'Employee',
            businessUnit: 'Business unit',
            date: 'End of employment',
            action: 'Action',
          },
        },
        missingTargets: {
          title: 'missing targets',
          header: 'Employees missing financial targets',
          text: 'If employees have a target bonus as part of their employment, targets must be agreed on to ensure the employee can fulfill them and claim the bonus.',
          tableColumns: {
            user: 'Employee',
            businessUnit: 'Business unit',
            missingAmount: 'Missing target Amount',
            action: 'Action',
          },
        },
        leavingSoon: {
          title: 'leaving soon',
          header: 'Employees leaving soon',
          text: 'These employees are leaving the company soon. Steps must be taken to ensure proper off boarding of the employee.',
          tableColumns: {
            user: 'Employee',
            businessUnit: 'Business unit',
            date: 'End of employment',
            action: 'Action',
          },
        },
      },
      meetings: {
        noMeetingsHeader: 'You have no upcoming meetings at the moment.',
        elapsedMeetingsAvailableHeader: 'You only have elapsed meetings at the moment.',
        notScheduled: 'has no scheduled appraisal.',
        infobox: {
          employee: {
            headline: 'employees',
          },
          appraisal: {
            headline: 'appraisals this year',
            openAppraisal: 'Open Appraisals',
            invited: 'Invited',
            confirmed: 'Confirmed',
          },
          nextMeeting: {
            headline: 'next meeting',
            startMeeting: 'start',
            prepareMeeting: 'prepare',
          },
          meetingInvite: {
            headline: 'Invite',
          },
        },
      },
    },
  },
}
